// Generate a random string.
// Used for generating uniquie ids
export function randomStr() {
  const str = Math.random().toString(36);
  return `${str}${str}`.substr(2, 10);
}

export default randomStr;



// WEBPACK FOOTER //
// src/configs/helpers.js